import classNames from "classnames";
import React, { memo, StatelessComponent } from "react";

import { groupTextClass, IStyleTextColor, IStyleWeight } from "../Style";

type Style = IStyleTextColor & IStyleWeight;

export interface ILinkProps extends Partial<Style> {
  onClick: () => void;
  href?: string;
}

export const Link: StatelessComponent<ILinkProps> = memo(({ children, color, href, onClick, weight }) => {
  const className = classNames("el-link", groupTextClass({ weight, color }));

  const props = Object.assign(
    {
      className,
      onClick,
    },
    href ? { href } : {},
  );

  return <a {...props}>{children}</a>;
});

export default Link;
